// components/CartProviderLayout.tsx
import { Outlet, useLocation } from "react-router-dom";
import { Box } from "@mui/material";
import CartFooter from "./CartFooter";
import { useCartStore } from "../../store/useCartStore";
import { useAuthStore } from "../../store/useAuthStore";

const CartProviderLayout = () => {
  const { isAuthenticated } = useAuthStore();
  const cartItems = useCartStore((state) => state.cartItems);

  const CartItemTotal = useCartStore((state) => state.getTotalQuantity());
  const location = useLocation();

  const onValidPage = ["/", "/checkout"].some((path) =>
    location.pathname.startsWith(path)
  );
  const showCartFooter =
    onValidPage && (isAuthenticated || cartItems.length > 0);

  return (
    <>
      <Box sx={{ pb: showCartFooter ? "81.02px" : 0 }}>
        <Outlet />
      </Box>
      {CartItemTotal > 0 && <CartFooter />}
    </>
  );
};

export default CartProviderLayout;
